import Icon from '@material-ui/core/Icon';
import Box from '@mui/material/Box';
import { muiFullWidthAndHeight } from 'assets/style/mui-theme';

export const svgIcon = (imageSource) => (
  <Icon>
    <Box component="img" src={imageSource} sx={muiFullWidthAndHeight} alt="" />
  </Icon>
);
